export const snakeCaseToReadableString = (snakeCaseString?: string): string => {
  if (snakeCaseString) {
    return snakeCaseString.replace(/(^[a-z])|_([a-z])/gi, $1 => {
      return $1.toUpperCase().replace("-", " ").replace("_", " ")
    })
  }
  return ""
}
